export default __webpack_public_path__ + "static/media/settingicon.39a9b48b.svg";